/**
 * Global click handler for anchor elements.
 */
document.addEventListener ("DOMContentLoaded", () => {
  document.addEventListener("click", (event) => {
    const anchorElement = event.target.closest("a[href^='#']");

    if (!anchorElement) {
      return;
    }

    const targetUrl = new URL(anchorElement.href);

    if (targetUrl.hash === "") {
      return;
    }

    const targetElement = document.querySelector(targetUrl.hash);

    if (!targetElement) {
      return;
    }

    event.preventDefault();

    targetElement.scrollIntoView({
      behavior: "smooth"
    });
  });
});
